import { render, staticRenderFns } from "./AadharDetails.vue?vue&type=template&id=28f3acf1"
import script from "./AadharDetails.vue?vue&type=script&lang=js"
export * from "./AadharDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports